import './App.css';
import Header from './component/Header';
import Footer from './component/Footer';
import Title from './component/Title';

function App() {
  return (
    <div className="App">
      <Header></Header>
      <Title></Title>
      <Footer></Footer>
    </div>
  );
}

export default App;
